<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      timer: null
    }
  },
  mounted() {},
  destroyed() {
    clearInterval(this.timer)
  }
}
</script>

<style lang="less">
.size {
  width: 100%;
  height: 100%;
}
html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}
#app {
  .size;
}
.el-tooltip__popper {
  max-width: 450px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue